import { Pipe, PipeTransform } from '@angular/core';

const WORD_REGEX = /\b[a-zA-Z]+\b/g;

@Pipe({
  name: 'formatName',
  pure: true
})
export class FormatNamePipe implements PipeTransform {
  transform(value: string, apply: boolean | string = false): string {
    const shouldApply = typeof apply === 'string'
      ? apply.toLowerCase() === 'true'
      : !!apply;
    if (!shouldApply || !value) return value;

    return value.replace(WORD_REGEX, word =>
      word.length > 2 
        ? `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
        : word
    );
  }
}